import React               from 'react';
import "./contactUs.scss";
import FormTable           from '../../reuseableComponents/Form/Form';
import HeadingNDescription from '../../reuseableComponents/headingNDescription/headingNDescription';

const ContactUs = () => {
  let data = [
    {
      label: "Name",
      value: "name",
      type: "inp",
      options: []
    },
    {
      label: "Email",
      value: "email",
      type: "inp",
      options: []
    },
    {
      label: "Description",
      value: "description",
      type: "textArea",
      options: [],
      style: { gridColumn: "span 2" }
    }
  ]
  return <div style={{
    height:"100vh"
  }}>
    <HeadingNDescription style={{
      paddingTop:100,
      marginTop:0,
      marginBottom:30
    }} heading={ "Let’s Contact us!" }
                         description={ "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s," }/>
    <FormTable data={ data } customStyle={
      {
        display: window.innerWidth > 790 ? "grid" : "",
        gridTemplateColumns: window.innerWidth > 790 ? "48% 48%" : "100%",
        width: "100%",
        marginTop: "3%",
        justifyContent:"space-between"
      } } buttonLabel={ "Send" }
               mainWidth={ window.innerWidth > 790 ? "50%" : "80%"}
    />
  </div>
}
export default ContactUs